import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormCheckbox} from '@social-native/snclient-ui';

/**
 * Individual creator item in the filter dropdown
 */
const CreatorFilterItem = ({creator, isSelected, onSelect}) => {
    const handleClick = (e) => {
        e.stopPropagation();
        onSelect();
    };

    return (
        <div
            className={classNames('creator-filter-item', {
                'creator-filter-item-selected': isSelected
            })}
            onClick={handleClick}
        >
            <FormCheckbox
                id={`content-creator-${creator.id}`}
                checked={isSelected}
                onChange={() => {}}
            />

            <span className="creator-filter-name">
                {creator.name}
            </span>
        </div>
    );
};

CreatorFilterItem.propTypes = {
    creator: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired
    }).isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired
};

export default CreatorFilterItem;



// WEBPACK FOOTER //
// ./brand/content_approval/creator_filter/creator_filter_item.js